module.exports = __webpack_public_path__ + "img/brokenGlass.7c934d1.png";